var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.777344,
    y: -1,
    width: 34,
    height: 34,
    fill: "url(#pattern0_2603_3201)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2603_3201",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2603_3201",
    transform: "translate(-0.34058) scale(0.00724638)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2603_3201",
    width: 232,
    height: 138,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOgAAACKCAIAAAAv95F+AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAA6KADAAQAAAABAAAAigAAAACXywRGAAADFElEQVR4Ae3WsW0DURBDQckQ4Mwdu0oBbsaBXQI3fMFc+jcghgzu8fARIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAjkBJ4/uUgCEdgCr89944JATuAjl0ggAgcBwz0gOekJGG6vE4kOAoZ7QHLSEzDcXicSHQQM94DkpCdguL1OJDoIGO4ByUlPwHB7nUh0EDDcA5KTnoDh9jqR6CBguAckJz0Bw+11ItFBwHAPSE56Aobb60Sig4DhHpCc9AQMt9eJRAcBwz0gOekJGG6vE4kOAoZ7QHLSEzDcXicSHQQM94DkpCdguL1OJDoIGO4ByUlPwHB7nUh0EDDcA5KTnoDh9jqR6CBguAckJz0Bw+11ItFBwHAPSE56Aobb60Sig4DhHpCc9AQMt9eJRAcBwz0gOekJGG6vE4kOAoZ7QHLSEzDcXicSHQQM94DkpCdguL1OJDoIGO4ByUlPwHB7nUh0EDDcA5KTnoDh9jqR6CBguAckJz2B19d3L5REBJbA8++9TrwT6Am8Hr+9UBIRWAL+cZeQ96SA4SZrEWoJGO4S8p4UMNxkLUItAcNdQt6TAoabrEWoJWC4S8h7UsBwk7UItQQMdwl5TwoYbrIWoZaA4S4h70kBw03WItQSMNwl5D0pYLjJWoRaAoa7hLwnBQw3WYtQS8Bwl5D3pIDhJmsRagkY7hLynhQw3GQtQi0Bw11C3pMChpusRaglYLhLyHtSwHCTtQi1BAx3CXlPChhushahloDhLiHvSQHDTdYi1BIw3CXkPSlguMlahFoChruEvCcFDDdZi1BLwHCXkPekgOEmaxFqCRjuEvKeFDDcZC1CLQHDXULekwKGm6xFqCVguEvIe1LAcJO1CLUEDHcJeU8KGG6yFqGWgOEuIe9JAcNN1iLUEvgHHzIE9LqAXd8AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.c531a032d12dec0a306d8fe41ec73c80.svg";
export { ForwardRef as ReactComponent };